var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\r\n\t.social-icon-svg{fill:#222D3D;}\r\n"),React.createElement("g",{"key":1},[React.createElement("g",{"key":0},React.createElement("path",{"className":"social-icon-svg","d":"M256,512C114.8,512,0,397.2,0,256S114.8,0,256,0s256,114.8,256,256S397.2,512,256,512z M256,9\r\n\t\t\tC119.8,9,9,119.8,9,256s110.8,247,247,247s247-110.8,247-247S392.2,9,256,9z"})),React.createElement("path",{"className":"social-icon-svg","d":"M319.2,265.9h-44.8v164.5h-68.1V265.9H174V208h32.3v-37.2c0-26.9,12.6-68.6,68.6-68.6H325v56h-36.8\r\n\t\tc-5.8,0-14.3,3.1-14.3,15.7V208h50.7L319.2,265.9z","key":1})])]);
}

Facebook.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","viewBox":"0 0 512 512","style":{"enableBackground":"new 0 0 512 512"},"xmlSpace":"preserve"};

module.exports = Facebook;

Facebook.default = Facebook;
